export default __webpack_public_path__ + "static/media/ic-chat.0eafab99.svg";